import { NavLink, useLocation } from "react-router-dom";
import { ChefHat, LayoutDashboard, BookOpen, ShieldAlert, CalendarCheck, Boxes, ClipboardList, MapPin, Users, Building2, Truck, ShoppingCart, Map } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { cn } from "@/lib/utils";

export const NAV = [
  { section: "Cucina", items: [
    { to: "/", label: "Dashboard chef", icon: LayoutDashboard, end: true },
    { to: "/ricette", label: "Ricettario", icon: BookOpen },
    { to: "/allergeni", label: "Matrice allergeni", icon: ShieldAlert },
    { to: "/produzione", label: "Piano di produzione", icon: CalendarCheck },
  ] },
  { section: "Magazzino", items: [
    { to: "/scorte", label: "Scorte", icon: Boxes },
    { to: "/inventario", label: "Inventario e scarico", icon: ClipboardList },
    { to: "/ubicazioni", label: "Ubicazioni", icon: MapPin },
  ] },
  { section: "Acquisti", items: [
    { to: "/fornitori", label: "Fornitori e listini", icon: Truck },
    { to: "/ordini", label: "Ordini", icon: ShoppingCart },
    { to: "/logistica", label: "Mappa consegne", icon: Map },
  ] },
  { section: "Amministrazione", admin: true, items: [
    { to: "/utenti", label: "Utenti", icon: Users },
    { to: "/sedi", label: "Sedi", icon: Building2 },
  ] },
];

export function breadcrumbFor(pathname) {
  for (const s of NAV) for (const i of s.items) {
    if (i.end ? pathname === i.to : pathname.startsWith(i.to)) return [s.section, i.label];
  }
  return ["Brigata"];
}

export function Sidebar() {
  const { user } = useAuth();
  const location = useLocation();
  return (
    <aside className="no-print hidden w-[250px] shrink-0 flex-col bg-[#1B2826] text-slate-200 md:flex" data-testid="sidebar">
      <div className="flex items-center gap-2.5 px-5 py-5">
        <span className="flex h-9 w-9 items-center justify-center rounded-md bg-[#1F5F57] text-white"><ChefHat className="h-5 w-5" /></span>
        <div><div className="text-base font-bold leading-tight text-white">Brigata</div><div className="text-[11px] text-slate-400">Gestionale operativo</div></div>
      </div>
      <nav className="flex-1 space-y-5 overflow-y-auto px-3 pb-4" aria-label="Navigazione principale">
        {NAV.filter((s) => !s.admin || user?.role === "admin").map((s) => (
          <div key={s.section}>
            <div className="px-2 pb-1.5 text-[11px] font-semibold uppercase tracking-wider text-slate-500">{s.section}</div>
            <ul className="space-y-0.5">
              {s.items.map((i) => {
                const active = i.end ? location.pathname === i.to : location.pathname.startsWith(i.to);
                return (
                  <li key={i.to}>
                    <NavLink to={i.to} data-testid={`nav-${i.to === "/" ? "dashboard" : i.to.slice(1)}`}
                      className={cn("flex items-center gap-2.5 rounded-md px-2.5 py-2 text-sm font-medium transition-colors",
                        active ? "bg-[#1F5F57] text-white" : "text-slate-300 hover:bg-white/5 hover:text-white")}>
                      <i.icon className="h-4 w-4 shrink-0" />{i.label}
                    </NavLink>
                  </li>
                );
              })}
            </ul>
          </div>
        ))}
      </nav>
      <div className="border-t border-white/10 px-5 py-3 text-xs text-slate-400">Fase 2 · Cucina, Magazzino e Acquisti</div>
    </aside>
  );
}

export function BottomTabs() {
  const tabs = [
    { to: "/", label: "Dashboard", icon: LayoutDashboard, end: true },
    { to: "/ricette", label: "Ricette", icon: BookOpen },
    { to: "/produzione", label: "Produzione", icon: CalendarCheck },
    { to: "/inventario", label: "Inventario", icon: ClipboardList },
  ];
  return (
    <nav className="no-print fixed inset-x-0 bottom-0 z-30 grid grid-cols-4 border-t border-slate-200 bg-white md:hidden" aria-label="Navigazione mobile" data-testid="bottom-tabs">
      {tabs.map((t) => (
        <NavLink key={t.to} to={t.to} end={t.end} data-testid={`tab-${t.label.toLowerCase()}`}
          className={({ isActive }) => cn("flex min-h-[56px] flex-col items-center justify-center gap-0.5 text-[11px] font-medium", isActive ? "text-[#1F5F57]" : "text-slate-500")}>
          <t.icon className="h-5 w-5" />{t.label}
        </NavLink>
      ))}
    </nav>
  );
}
